export default __webpack_public_path__ + "static/media/mohammad_abu_baker.c0216b27.jpg";